var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"parking-enter-container",on:{"click":_vm.hideKeyboard}},[_c('Header'),_c('div',{staticClass:"main-container"},[_c('Content')],1),_c('Footer'),_c('PlateKeyboard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }